var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.block},[_c('div',{class:_vm._.title},[_vm._v("购买须知")]),_c('div',{class:[_vm._.content, _vm._._hairlineTop]},[_c('JointBuyNotice',{attrs:{"value":_vm.jointGoodsModel.purchaseNotesDetail}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }